"use client";

import {VStack} from "@styled-system/jsx";
import Link from "next/link";

import {usePlayerSetupContext} from "@/providers/context.provider";

import {PrimaryCTAButton} from "../custom/common/primaryCTAButton";
import {JindoWhiteWithSplashIcon} from "../icon";
import {Input} from "../primitives/input";
import {Paragraph} from "../primitives/typography";

import {css} from "@styled-system/css";

export const PlayerSetupComponent = () => {
    const ctx = usePlayerSetupContext();

    return (
        <VStack
            align={"center"}
            height={"100%"}
            width={"100%"}
            css={{
                bg: "linear-gradient(168.7deg, #ff0000 -2.34%, #ff8a00 31.14%, #f19f00 65.04%, #ff0000 99.17%)"
            }}
            onKeyDown={ctx.handleKeyDown}
            tabIndex={0}>
            <VStack align={"center"} justify={"space-between"} height={"100%"} width={"100%"} pb="100px">
                <VStack align={"center"} height={"100%"} width={"containerSize"}>
                    <JindoWhiteWithSplashIcon width={180} height={150} />
                    <VStack align={"center"} gap={10} width={"100%"}>
                        <Paragraph size="xLarge" fontFamily={"condensedHeading"}>
                            JOIN YOUR HOST&apos;S JAM
                        </Paragraph>
                        <VStack align={"center"} gap={"4"} width={"100%"}>
                            <Paragraph size="large" fontFamily={"condensedHeading"}>
                                Enter your name to jump into your Host&apos;s Jam.
                            </Paragraph>
                            <Input size="lg" css={{minWidth: "325px", maxWidth: "640px"}}>
                                <Input.Text
                                    className={css({
                                        fontFamily: "Barlow Condensed",
                                        fontWeight: "semibold",
                                        fontSize: "21px",
                                        letterSpacing: "0.02em"
                                    })}
                                    placeholder="Enter your player name"
                                    value={ctx.name}
                                    onChange={(e) => ctx.setName(e.target.value)}
                                />
                            </Input>
                        </VStack>
                        <VStack align={"center"} gap={"6"} width={"100%"} mt={10}>
                            <Paragraph size="medium" fontFamily={"condensedHeading"} css={{textAlign: "center"}}>
                                You can also sign up to become a host and set up your very own Jindo Jams!
                            </Paragraph>
                            <Paragraph size="medium" fontFamily={"condensedHeading"}>
                                <Link
                                    href="https://www.playjindo.com/pricing-plans"
                                    style={{textDecoration: "underline"}}>
                                    Learn more and sign up today!
                                </Link>
                            </Paragraph>
                            <Paragraph style={{fontFamily: "Barlow Condensed", fontSize: "12px", textShadow: "text"}}>
                                By Joining this game you agree to our{" "}
                                <Link
                                    href="https://www.playjindo.com/privacy-policy-info"
                                    style={{textDecoration: "underline"}}>
                                    Terms & Conditions
                                </Link>
                            </Paragraph>
                        </VStack>
                    </VStack>
                </VStack>
                <PrimaryCTAButton
                    ref={ctx.joinGameButtonRef}
                    isDisabled={ctx.isPendingPlayerLogin || !ctx.name.trim()}
                    isLoading={ctx.isPendingPlayerLogin}
                    onClick={() => ctx.joinGame()}>
                    {"JOIN GAME + START JAMMING"}
                </PrimaryCTAButton>
            </VStack>
        </VStack>
    );
};
